import '../custom-Jquery';

/**
 *  Javascript utilisé par le bloc "Combien ca coute" ou "Crédit d'impot" présent sur les pages Primaire, Collège, Lycée, Supérieur
 * 
 */
 (function(w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({},w.Completude);
    w.Completude.bloc_combien_ca_coute  = {                
        /**
         * Initialisation 
         */
        InitBlocCombienCaCoute() {
            try {
                let niveau = jQuery('#section-bloc-combien-ca-coute').data("niveau");
                var devis = null;
                if (typeof niveau === 'undefined' || niveau==='') {
                    // Pas de niveau définit sur la page (page générique cours-particuliers-a-domicile)
                    // on prend ce que l'on trouve
                    devis = Completude.GetStorage("form-demande-tarifs-niveau-1") ||
                    Completude.GetStorage("form-demande-tarifs-niveau-2") ||
                    Completude.GetStorage("form-demande-tarifs-niveau-3") ||
                    Completude.GetStorage("form-demande-tarifs-niveau-4") ||
                    Completude.GetStorage("form-demande-tarifs-niveau-5")                    

                } else {
                     devis =  Completude.GetStorage("form-demande-tarifs-niveau-" +  niveau);
                }
                if (typeof(devis)!=='undefined' && devis!==null) {
                    // IL y a un devis qui a déjà été fait, on masque le bloc Crédit d'impot et on affiche le bloc "Devis"                
                    //$("#bloc-combien-ca-coute-devis").mapObject(devis,"mapping"); // Map toutes les proriétés data-mapping="NomdeLaProrpiete"
                    $("#bloc-combien-ca-coute-devis div.rate-details").html(devis.tpl);
                    $("#bloc-combien-ca-coute-credit-impot").addClass("hide");
                    $("#bloc-combien-ca-coute-devis").removeClass("hide");
                    
                    // Si l'agence par defaut n'est pas attribuée
                    // on utilise l'agence stockée dans devis.agence
                    if (typeof(Completude.agence)==='undefined' || Completude.agence===null) {
                        Completude.agence = devis.agence;
                        Completude.UpdateAgence();
                    }
                }
                

            }
            catch (e) {console.log("erreur dans InitBlocCombienCaCoute")}
        },
        
}})(window);

jQuery(function() {          
    if( jQuery('#section-bloc-combien-ca-coute').length > 0 ) {
        Completude.bloc_combien_ca_coute.InitBlocCombienCaCoute();
    }   

});